export default __webpack_public_path__ + "static/media/time-to-vote-grouped.08afb4ce.webp";